module.exports = __webpack_public_path__ + "static/get-everyone-on-same-page-d689ab2d3b473eed00bb61f5e5a7cc40.mp4";